// Time-of-day greeting (COTC_FriendsApprovals R4 / DESIGN §3.1). Pure so it can be tested with a
// fixed clock.

export type Daypart = 'morning' | 'afternoon' | 'evening'

export function daypartOf(now: Date): Daypart {
  const h = now.getHours()
  if (h < 12) return 'morning'
  if (h < 18) return 'afternoon'
  return 'evening'
}

/** "Good evening, {name}." headline + "Tuesday evening" mono kicker. */
export function homeGreeting(now: Date, guardianFirst: string): { title: string; kicker: string } {
  const part = daypartOf(now)
  const weekday = now.toLocaleDateString('en-GB', { weekday: 'long' })
  return {
    title: `Good ${part}, ${guardianFirst || 'there'}.`,
    kicker: `${weekday} ${part}`,
  }
}
